import React from "react";
//import styled from "styled-components";

//import WizardForm from "../../FormWizard/WizardForm";
//import { Values } from "redux-form-website-template";

// UI
import BasePage from "../../../UI/BasePage/BasePage";
import Aux from "../../../hoc/Aux";
import {
  CardSection,
  Container
} from "../../../UI/ContentSection/ContentSection";

// images
import pioneerMainImg from "../../../assests/images/pioneerMain.png";

// content
import { content } from "./Content/auditionTexts";
import ContentCard from "../../../UI/ContentCard/ContentCard";
import Pioneer from "./Content/Pioneer";

const Audition = () => (
  <Aux>
    <BasePage
      title={"AUDITION FOR SAMPELL PIONEER"}
      image={pioneerMainImg}
      textLineOne={
        "WITH DESIGNERS AND STREET ARTISTS WE BUILD UP A PORTFOLIO OF UNIQUE"
      }
      textLineTwo={
        "PRINT DESIGNS. YOU AS WELL CAN SUBMIT A DESIGN. A JURY WILL VOTE IF YOUR"
      }
      textLineThree={"DESIGN MAKES IT INTO OUR PORTFOLIO."}
    />
    <CardSection>
      <Container>
        <Pioneer />
        {content.map((pioneer, index) => (
          <ContentCard
            key={index}
            title={pioneer.title}
            id={pioneer.id}
            image={pioneer.image}
            imageTitle={pioneer.title}
            frontText={pioneer.text}
            backTextOne={pioneer.textOne}
            backTextTwo={pioneer.textTwo}
            backTextThree={pioneer.textThree}
            item1={pioneer.item1}
            item2={pioneer.item2}
            item3={pioneer.item3}
            item4={pioneer.item4}
            item5={pioneer.item5}
            item6={pioneer.item6}
            item7={pioneer.item7}
            item8={pioneer.item8}
            item9={pioneer.item9}
            item10={pioneer.item10}
            item11={pioneer.item11}
          />
        ))}
      </Container>
    </CardSection>
    {/*<CenteredCardSection>*/}
    {/*<Container>*/}
    {/*<ImageContainer>*/}
    {/*<Title>{content.dutiePioneer.title}</Title>*/}
    {/*<img*/}
    {/*src={dutiesImg}*/}
    {/*alt="These are the Duties of a SAMPELL-Pioneer"*/}
    {/*/>*/}
    {/*</ImageContainer>*/}
    {/*<TextContainer>*/}
    {/*<p>{content.dutiePioneer.mainText}</p>*/}
    {/*</TextContainer>*/}
    {/*</Container>*/}
    {/*<Container>*/}
    {/*<ImageContainer>*/}
    {/*<Title>{content.benefitPioneer.title}</Title>*/}
    {/*<img*/}
    {/*src={befitsImg}*/}
    {/*alt="These are the Benefits for a SAMPELL-Pioneer"*/}
    {/*/>*/}
    {/*</ImageContainer>*/}
    {/*<TextContainer>*/}
    {/*<p>{content.benefitPioneer.mainText}</p>*/}
    {/*</TextContainer>*/}
    {/*</Container>*/}
    {/*<Container>*/}
    {/*<ImageContainer>*/}
    {/*<Title>{content.criteriaPioneer.title}</Title>*/}
    {/*<img*/}
    {/*src={criteriaImg}*/}
    {/*alt="These are the Criteria to become for a SAMPELL-Pioneer"*/}
    {/*/>*/}
    {/*</ImageContainer>*/}
    {/*<TextContainer>*/}
    {/*<p>You like unique clothes.</p>*/}
    {/*<p>You care for clothes of high quality for a fair price.</p>*/}
    {/*<p>You wear hoodies.</p>*/}
    {/*<p>You can relate to our approach of unisex fashion.</p>*/}
    {/*<p>You are tolerant and open minded.</p>*/}
    {/*<p>You like design and creativity.</p>*/}
    {/*<p>You like to communicate and share your ideas on Social Media. </p>*/}
    {/*<p>*/}
    {/*You are open to share your SAMPELL experiences with our online*/}
    {/*community - for instance in the context of written comments, video*/}
    {/*interviews or pictures of you.*/}
    {/*</p>*/}
    {/*<p>*/}
    {/*You care for fashion that is produced under fair circumstances for*/}
    {/*people and environment.*/}
    {/*</p>*/}
    {/*<p>*/}
    {/*No age restriction. If you are under 18, we would like for your*/}
    {/*parents to agree, that you take part in our project.*/}
    {/*</p>*/}
    {/*</TextContainer>*/}
    {/*</Container>*/}
    {/*<Container>*/}
    {/*<ImageContainer>*/}
    {/*<Title>APPLICATION FORM</Title>*/}
    {/*<img src={formImg} alt="Applie as SAMPELL-Pioneer" />*/}
    {/*</ImageContainer>*/}
    {/*<FormContainer>*/}
    {/*<WizardForm />*/}
    {/*<Values form="wizard" />*/}
    {/*Fashion Background Social Media account: facebook instagram twitter*/}
    {/*youtube social media follower why do you want to become sampell*/}
    {/*pioneer? upload a picture*/}
    {/*</FormContainer>*/}
    {/*</Container>*/}
    {/*</CenteredCardSection>*/}
  </Aux>
);

export default Audition;



// WEBPACK FOOTER //
// ./src/components/Pages/Audition/Audition.js